export default function Services() {
  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-6">
            Des solutions de transport réactives partout en Île-de-France
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Services professionnels de transport et livraison pour tous vos besoins en région parisienne
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Coursier Express */}
          <div className="group bg-gradient-to-br from-gray-50 to-white p-8 rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-orange-200">
            <div className="mb-6 relative">
              <img 
                src="https://public.readdy.ai/ai/img_res/1642fddf87cb919904881e990197a309.jpg"
                alt="Coursier Express Île-de-France - Livraison urgente de plis et colis"
                title="Service de coursier express en Île-de-France"
                className="w-24 h-24 object-contain group-hover:scale-110 transition-transform duration-300"
                loading="lazy"
              />
            </div>
            <h3 className="text-2xl font-bold mb-4 text-gray-900">
              Coursier Express : Livraison urgente de plis et colis (75, 77, 78, 91, 92, 93, 94, 95)
            </h3>
            <p className="text-gray-600 mb-6 leading-relaxed">
              Besoin d'une <strong>livraison express en Île-de-France</strong> ? Notre service de <strong>coursier professionnel</strong> intervient dans tous les départements franciliens pour vos envois urgents de documents, colis et marchandises. Livraison rapide et sécurisée dans Paris et toute la région.
            </p>
            <ul className="space-y-3 mb-6">
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-xl text-green-600 mt-1"></i>
                <span className="text-gray-700">Livraison en moins d'1 heure dans Paris</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-xl text-green-600 mt-1"></i>
                <span className="text-gray-700">Service disponible 24h/24 et 7j/7</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-xl text-green-600 mt-1"></i>
                <span className="text-gray-700">Suivi en temps réel de votre colis</span>
              </li>
            </ul>
            <a
              href="/coursier-paris"
              className="inline-flex items-center text-orange-600 font-semibold hover:text-orange-700 transition-colors group-hover:gap-3 gap-2"
            >
              En savoir plus
              <i className="ri-arrow-right-line text-xl"></i>
            </a>
          </div>

          {/* Transport de marchandises */}
          <div className="group bg-gradient-to-br from-gray-50 to-white p-8 rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-orange-200">
            <div className="mb-6 relative">
              <img 
                src="https://readdy.ai/api/search-image?query=3d%20icon%20of%20delivery%20truck%20in%20motion%20with%20green%20and%20emerald%20gradient%20modern%20minimalist%20style%20with%20glossy%20surface%20and%20soft%20shadows%20representing%20professional%20freight%20transportation%20on%20transparent%20or%20white%20background&width=200&height=200&seq=service-transport-icon-001&orientation=squarish"
                alt="Transport de marchandises Île-de-France - Tournées régulières pour entreprises"
                title="Service de transport de marchandises en Île-de-France"
                className="w-24 h-24 object-contain group-hover:scale-110 transition-transform duration-300"
                loading="lazy"
              />
            </div>
            <h3 className="text-2xl font-bold mb-4 text-gray-900">
              Transport de marchandises et tournées régulières pour les entreprises franciliennes
            </h3>
            <p className="text-gray-600 mb-6 leading-relaxed">
              Solution complète de <strong>transport de marchandises en Île-de-France</strong> pour les professionnels. Nous assurons vos <strong>tournées régulières</strong>, livraisons de dernier kilomètre et transport de palettes dans toute la région parisienne avec ponctualité et fiabilité.
            </p>
            <ul className="space-y-3 mb-6">
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-xl text-green-600 mt-1"></i>
                <span className="text-gray-700">Tournées programmées et régulières</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-xl text-green-600 mt-1"></i>
                <span className="text-gray-700">Transport de palettes et gros volumes</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-xl text-green-600 mt-1"></i>
                <span className="text-gray-700">Livraisons de dernier kilomètre optimisées</span>
              </li>
            </ul>
            <a
              href="/transport-paris"
              className="inline-flex items-center text-orange-600 font-semibold hover:text-orange-700 transition-colors group-hover:gap-3 gap-2"
            >
              En savoir plus
              <i className="ri-arrow-right-line text-xl"></i>
            </a>
          </div>

          {/* Location camion avec chauffeur */}
          <div className="group bg-gradient-to-br from-gray-50 to-white p-8 rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-orange-200">
            <div className="mb-6 relative">
              <img 
                src="https://readdy.ai/api/search-image?query=3d%20icon%20of%20package%20box%20with%20ribbon%20in%20red%20and%20coral%20gradient%20modern%20minimalist%20style%20with%20glossy%20surface%20and%20soft%20shadows%20representing%20standard%20delivery%20service%20on%20transparent%20or%20white%20background&width=200&height=200&seq=service-standard-icon-001&orientation=squarish"
                alt="Location camion avec chauffeur Île-de-France - Déménagement région parisienne"
                title="Service de location d'utilitaire avec chauffeur en Île-de-France"
                className="w-24 h-24 object-contain group-hover:scale-110 transition-transform duration-300"
                loading="lazy"
              />
            </div>
            <h3 className="text-2xl font-bold mb-4 text-gray-900">
              Location de camion avec chauffeur : Simplifiez vos déménagements en région parisienne
            </h3>
            <p className="text-gray-600 mb-6 leading-relaxed">
              Besoin d'un <strong>camion avec chauffeur en Île-de-France</strong> ? Notre service de <strong>location d'utilitaire avec chauffeur professionnel</strong> vous simplifie la vie : pas de caution, pas de stress de conduite dans Paris. Idéal pour déménagements, livraisons volumineuses et transport de meubles.
            </p>
            <ul className="space-y-3 mb-6">
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-xl text-green-600 mt-1"></i>
                <span className="text-gray-700">Pas de caution ni de permis requis</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-xl text-green-600 mt-1"></i>
                <span className="text-gray-700">Chauffeur expérimenté dans le trafic parisien</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-xl text-green-600 mt-1"></i>
                <span className="text-gray-700">Véhicules adaptés à tous volumes</span>
              </li>
            </ul>
            <a
              href="/demenagement-paris"
              className="inline-flex items-center text-orange-600 font-semibold hover:text-orange-700 transition-colors group-hover:gap-3 gap-2"
            >
              En savoir plus
              <i className="ri-arrow-right-line text-xl"></i>
            </a>
          </div>

          {/* Livraison Express */}
          <div className="group bg-gradient-to-br from-gray-50 to-white p-8 rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-orange-200">
            <div className="mb-6 relative">
              <img 
                src="https://readdy.ai/api/search-image?query=3d%20icon%20of%20stopwatch%20chronometer%20with%20motion%20effect%20in%20orange%20and%20amber%20gradient%20modern%20minimalist%20style%20with%20glossy%20surface%20and%20soft%20shadows%20representing%20urgent%20time-sensitive%20delivery%20on%20transparent%20or%20white%20background&width=200&height=200&seq=service-urgent-icon-001&orientation=squarish"
                alt="Livraison Express Paris - Service rapide et fiable"
                title="Service de livraison express à Paris et Île-de-France"
                className="w-24 h-24 object-contain group-hover:scale-110 transition-transform duration-300"
                loading="lazy"
              />
            </div>
            <h3 className="text-2xl font-bold mb-4 text-gray-900">Livraison Express Paris</h3>
            <p className="text-gray-600 mb-6 leading-relaxed">
              Service de <strong>livraison express à Paris</strong> pour vos envois urgents. Coursier rapide disponible immédiatement pour une livraison dans l'heure partout dans la capitale et sa proche banlieue.
            </p>
            <ul className="space-y-3 mb-6">
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-xl text-green-600 mt-1"></i>
                <span className="text-gray-700">Prise en charge immédiate</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-xl text-green-600 mt-1"></i>
                <span className="text-gray-700">Livraison garantie en moins d'1h</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-xl text-green-600 mt-1"></i>
                <span className="text-gray-700">Coursier moto pour éviter les embouteillages</span>
              </li>
            </ul>
            <a
              href="/livraison-express-paris"
              className="inline-flex items-center text-orange-600 font-semibold hover:text-orange-700 transition-colors group-hover:gap-3 gap-2"
            >
              En savoir plus
              <i className="ri-arrow-right-line text-xl"></i>
            </a>
          </div>

          {/* Déménagement */}
          <div className="group bg-gradient-to-br from-gray-50 to-white p-8 rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-orange-200">
            <div className="mb-6 relative">
              <img 
                src="https://readdy.ai/api/search-image?query=3d%20icon%20of%20moving%20boxes%20stacked%20with%20home%20symbol%20in%20blue%20and%20teal%20gradient%20modern%20minimalist%20style%20with%20glossy%20surface%20and%20soft%20shadows%20representing%20relocation%20moving%20service%20on%20transparent%20or%20white%20background&width=200&height=200&seq=service-moving-icon-001&orientation=squarish"
                alt="Déménagement Paris - Service complet avec équipe"
                title="Service de déménagement à Paris et Île-de-France"
                className="w-24 h-24 object-contain group-hover:scale-110 transition-transform duration-300"
                loading="lazy"
              />
            </div>
            <h3 className="text-2xl font-bold mb-4 text-gray-900">Déménagement Paris</h3>
            <p className="text-gray-600 mb-6 leading-relaxed">
              Service de <strong>déménagement à Paris</strong> clé en main. Notre équipe professionnelle s'occupe de tout : emballage, chargement, transport et déchargement de vos biens en toute sécurité.
            </p>
            <ul className="space-y-3 mb-6">
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-xl text-green-600 mt-1"></i>
                <span className="text-gray-700">Équipe de déménageurs professionnels</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-xl text-green-600 mt-1"></i>
                <span className="text-gray-700">Matériel d'emballage fourni</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-xl text-green-600 mt-1"></i>
                <span className="text-gray-700">Assurance tous risques incluse</span>
              </li>
            </ul>
            <a
              href="/demenagement-paris"
              className="inline-flex items-center text-orange-600 font-semibold hover:text-orange-700 transition-colors group-hover:gap-3 gap-2"
            >
              En savoir plus
              <i className="ri-arrow-right-line text-xl"></i>
            </a>
          </div>

          {/* Transport Urgent */}
          <div className="group bg-gradient-to-br from-gray-50 to-white p-8 rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-orange-200">
            <div className="mb-6 relative">
              <img 
                src="https://readdy.ai/api/search-image?query=3d%20icon%20of%20alarm%20bell%20with%20urgent%20notification%20in%20red%20and%20orange%20gradient%20modern%20minimalist%20style%20with%20glossy%20surface%20and%20soft%20shadows%20representing%20emergency%20urgent%20transport%20on%20transparent%20or%20white%20background&width=200&height=200&seq=service-emergency-icon-001&orientation=squarish"
                alt="Transport Urgent Paris - Disponible 24/7"
                title="Service de transport urgent à Paris et Île-de-France"
                className="w-24 h-24 object-contain group-hover:scale-110 transition-transform duration-300"
                loading="lazy"
              />
            </div>
            <h3 className="text-2xl font-bold mb-4 text-gray-900">Transport Urgent 24/7</h3>
            <p className="text-gray-600 mb-6 leading-relaxed">
              Service de <strong>transport urgent disponible 24h/24</strong> pour toutes vos situations d'urgence. Intervention rapide à Paris et en Île-de-France, même la nuit, le weekend et les jours fériés.
            </p>
            <ul className="space-y-3 mb-6">
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-xl text-green-600 mt-1"></i>
                <span className="text-gray-700">Disponible 24h/24, 7j/7</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-xl text-green-600 mt-1"></i>
                <span className="text-gray-700">Intervention en moins de 30 minutes</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-xl text-green-600 mt-1"></i>
                <span className="text-gray-700">Service weekend et jours fériés</span>
              </li>
            </ul>
            <a
              href="/transport-paris"
              className="inline-flex items-center text-orange-600 font-semibold hover:text-orange-700 transition-colors group-hover:gap-3 gap-2"
            >
              En savoir plus
              <i className="ri-arrow-right-line text-xl"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
